/**
 * Feature flags — driven by REACT_APP_* environment variables so they are
 * baked into the bundle at build time and ship as dead-code-eliminated
 * constants in production.
 *
 * To enable a flag in development, create a .env.local file at the
 * client/ root with the variable set to "true".  The .env.production file
 * holds the authoritative production values.
 */

/**
 * STRIPE_PAYMENTS_ENABLED
 *
 * Controls every Stripe-related payment surface:
 *   - "Stripe (Customer QR)" option in the employee Collect Payment modal
 *   - "Allow online payments (Stripe)" toggle in the Layaway Wizard
 *   - "Pass online platform fee" toggle in the Layaway Wizard
 *   - "💳 Pay Online" button on the customer / employee layaway view
 *
 * Set REACT_APP_STRIPE_PAYMENTS_ENABLED=true  to enable.
 * Omitting the variable, or setting it to anything else, disables.
 */
export const STRIPE_PAYMENTS_ENABLED =
    process.env.REACT_APP_STRIPE_PAYMENTS_ENABLED === 'true';
